import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#8AB73A',
        secondary: '#4DA5B8',
        accent: '#49C497',
        info: '#486DC7',
        error: '#CF612D',
        success: '#35C43C',
        warning:'#C4B735'
      },
      dark: {
        primary: '#683BB8',
        secondary: '#30B392',
        accent: '#0A17CC',
        info: '#2B95C4',
        error: '#B8674D',
        success: '#55991A',
        warning:'#B3AC27'
      },
    },
  },
}

export default new Vuetify(opts)
